/**
 * @file コラムの目次作成
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname ColumnTocCreate
 * @classdesc コラムの目次作成
 */
export default class ColumnTocCreate {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.section.column .board')
	 */
	constructor($e) {
		console.log('ColumnTocCreate.constructor')
		this._$e = $e
		this._$headings = $e.find('h3.board-header.board-header--left-line, h2.board-header.board-header--updown-line')
		const $tocList = $('.block--toc .list')
		const $sectionToc = $('.section.toc')
		const $column = $('.sticky-side.column')
		const $body = $('body')
		let toc = [];
		if(this._$headings.length > 0){
			this._$headings.each((idx, e) => {
				const $e = $(e)
				toc.push($e.text())
			})
		}
		if(toc.length > 0){
			for(let i = 0; i < toc.length; ++i) {
				const item =  `<li class="list-item"><a class="anchor" href="javascript:void(0);">${toc[i]}</a></li>`;
				$tocList.append(item)
			}
		}else {
			$sectionToc.css('display', 'none')
			$column.css('width', '100%')
			$body.addClass('contents')
		}

		$tocList.find('.list-item .anchor').each((idx, e) => {
			const $e = $(e)
			$e.on('click', (e) => this.onClick(e))
		})
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof ColumnTocCreate
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('ColumnTocCreate.onClick')
		const headingText = $(e.target).text()
		let position
		const marginTop = $(window).width() > 768 ? 70 : 50

		this._$headings.each((idx, e) => {
			const $e = $(e)
			if($e.text() === headingText){
				position = $e.offset().top  - marginTop
				$("html, body").animate({ scrollTop: position }, 500, "swing");
			}
		})
	}
}
